// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.equipmentByFaultTableWrapper__jwh5C {
  background: var(--tables-secondary-row-sub-title-surface);
  padding: 15px;
}

.equipmentByFaultTable__pCNB9 {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  position: relative;
  box-shadow: var(--basic-box-shadow);
}
.equipmentByFaultTable__pCNB9 th {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  text-transform: uppercase;
  color: var(--tables-title-text);
  padding: 16px 25px;
  border-bottom: 1px solid var(--tables-title-stroke);
  background: var(--tables-title-surface);
  text-align: left;
  text-wrap: nowrap;
}
@media (max-width: 980px) {
  .equipmentByFaultTable__pCNB9 th {
    padding: 16px 15px;
  }
}
.equipmentByFaultTable__pCNB9 td {
  padding: 10px 25px;
  color: var(--tables-primary-row-text-main);
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-primary-row-surface-default);
  white-space: normal;
  font-size: 14px;
  line-height: 16px;
}
@media (max-width: 980px) {
  .equipmentByFaultTable__pCNB9 td {
    padding: 10px 15px;
  }
}
@media (max-width: 860px) {
  .equipmentByFaultTable__pCNB9 td {
    font-size: 12px;
  }
}

.bodyRow__HpIAn:hover td {
  background: var(--tables-primary-row-surface-hover);
  border-bottom: 1px solid var(--tables-primary-row-stroke);
}

.sortIcon__E3khM {
  margin-left: 5px;
  cursor: pointer;
  outline: none;
  min-width: 6px;
}
.sortIcon__E3khM path {
  fill: var(--tables-title-icon);
}

.activeSort__yuyZk path {
  fill: var(--tables-primary-row-icon);
}

.facilityName__Cv5Lm {
  font-size: 11px;
  font-weight: 400;
  color: var(--tables-primary-row-text-additional);
}

.iconColumn__Tz6HG {
  text-align: right;
  cursor: pointer;
}

.viewDetailsIcon__KpExt {
  outline: none;
  vertical-align: baseline;
}
.viewDetailsIcon__KpExt path {
  stroke: var(--buttons-surface);
}

.skeletonText__NssYE {
  height: 15px;
}

.skeletonIcon__SDgNO {
  width: 15px;
  height: 15px;
  vertical-align: bottom;
  vertical-align: -webkit-baseline-middle;
}

.multiTableSortMenuWrapper__I3v08 {
  display: flex;
  align-items: center;
  gap: 5px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/FailureCauseCategories/components/EquipmentByFaultTable/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,yDAAA;EACA,aAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mCAAA;AAzEF;AA2EE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,+BAAA;EACA,kBAAA;EACA,mDAAA;EACA,uCAAA;EACA,gBAAA;EACA,iBAAA;AAzEJ;AA2EI;EAZF;IAaI,kBAAA;EAxEJ;AACF;AA2EE;EACE,kBAAA;EACA,0CAAA;EACA,yDAAA;EACA,qDAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AAzEJ;AA2EI;EATF;IAUI,kBAAA;EAxEJ;AACF;AA0EI;EAbF;IAcI,eAAA;EAvEJ;AACF;;AA4EE;EACE,mDAAA;EACA,yDAAA;AAzEJ;;AA6EA;EACE,gBAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;AA1EF;AA4EE;EACE,8BAAA;AA1EJ;;AA+EE;EACE,oCAAA;AA5EJ;;AAgFA;EACE,eAAA;EACA,gBAAA;EACA,gDAAA;AA7EF;;AAgFA;EACE,iBAAA;EACA,eAAA;AA7EF;;AAgFA;EACE,aAAA;EACA,wBAAA;AA7EF;AA+EE;EACE,8BAAA;AA7EJ;;AAiFA;EACE,YAAA;AA9EF;;AAiFA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,uCAAA;AA9EF;;AAiFA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA9EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.equipmentByFaultTableWrapper {\n  background: var(--tables-secondary-row-sub-title-surface);\n  padding: 15px;\n}\n\n.equipmentByFaultTable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  position: relative;\n  box-shadow: var(--basic-box-shadow);\n\n  th {\n    font-size: 10px;\n    font-weight: 400;\n    line-height: 12px;\n    text-transform: uppercase;\n    color: var(--tables-title-text);\n    padding: 16px 25px;\n    border-bottom: 1px solid var(--tables-title-stroke);\n    background: var(--tables-title-surface);\n    text-align: left;\n    text-wrap: nowrap;\n\n    @media (max-width: 980px) {\n      padding: 16px 15px;\n    }\n  }\n\n  td {\n    padding: 10px 25px;\n    color: var(--tables-primary-row-text-main);\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    background: var(--tables-primary-row-surface-default);\n    white-space: normal;\n    font-size: 14px;\n    line-height: 16px;\n\n    @media (max-width: 980px) {\n      padding: 10px 15px;\n    }\n\n    @media (max-width: 860px) {\n      font-size: 12px;\n    }\n  }\n}\n\n.bodyRow {\n  &:hover td {\n    background: var(--tables-primary-row-surface-hover);\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n  }\n}\n\n.sortIcon {\n  margin-left: 5px;\n  cursor: pointer;\n  outline: none;\n  min-width: 6px;\n\n  path {\n    fill: var(--tables-title-icon);\n  }\n}\n\n.activeSort {\n  path {\n    fill: var(--tables-primary-row-icon);\n  }\n}\n\n.facilityName {\n  font-size: 11px;\n  font-weight: 400;\n  color: var(--tables-primary-row-text-additional);\n}\n\n.iconColumn {\n  text-align: right;\n  cursor: pointer;\n}\n\n.viewDetailsIcon {\n  outline: none;\n  vertical-align: baseline;\n\n  path {\n    stroke: var(--buttons-surface);\n  }\n}\n\n.skeletonText {\n  height: 15px;\n}\n\n.skeletonIcon {\n  width: 15px;\n  height: 15px;\n  vertical-align: bottom;\n  vertical-align: -webkit-baseline-middle;\n}\n\n.multiTableSortMenuWrapper {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"equipmentByFaultTableWrapper": `equipmentByFaultTableWrapper__jwh5C`,
	"equipmentByFaultTable": `equipmentByFaultTable__pCNB9`,
	"bodyRow": `bodyRow__HpIAn`,
	"sortIcon": `sortIcon__E3khM`,
	"activeSort": `activeSort__yuyZk`,
	"facilityName": `facilityName__Cv5Lm`,
	"iconColumn": `iconColumn__Tz6HG`,
	"viewDetailsIcon": `viewDetailsIcon__KpExt`,
	"skeletonText": `skeletonText__NssYE`,
	"skeletonIcon": `skeletonIcon__SDgNO`,
	"multiTableSortMenuWrapper": `multiTableSortMenuWrapper__I3v08`
};
module.exports = ___CSS_LOADER_EXPORT___;
